import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/adjudicatario';
const RESOURCE_SEARCH = '/v2/buscar/aduana_adjudicatario';

export const successfulBiddersList = ({
  page, items, filters, order, format
}) => {
  const params = apiClient.queryParamsComponent(
    {
      filtros: filters,
      pagina: page,
      itemsPorPagina: items,
      orden: order,
      formato: format
    }
  );
  return apiClient.get(`${RESOURCE_SEARCH}?${params}`, {
    operacionId: 'aduanas.successfulBidders.list',
    permiso: 'ADU09'
  });
};

export const successfulBiddersCreate = ({
  type,
  name,
  identification,
  passport,
  country,
  address,
  commune,
  city,
  region,
  phone,
  email,
  giro
}) => apiClient.post(`${RESOURCE}`, {
  tipo: type,
  nombre: name,
  rut: identification,
  pasaporte: passport,
  pais: country,
  direccion: address,
  comuna: commune,
  ciudad: city,
  region,
  telefono: phone,
  correo: email,
  giro
}, {
  operacionId: 'aduanas.successfulBidders.create',
  permiso: 'ADU10'
});

export const successfulBiddersUpdate = ({
  id,
  type,
  name,
  identification,
  passport,
  country,
  address,
  commune,
  city,
  region,
  phone,
  email,
  giro
}) => apiClient.put(`${RESOURCE}/${id}`, {
  tipo: type,
  nombre: name,
  rut: identification,
  pasaporte: passport,
  pais: country,
  direccion: address,
  comuna: commune,
  ciudad: city,
  region,
  telefono: phone,
  correo: email,
  giro
}, {
  operacionId: 'aduanas.successfulBidders.update',
  permiso: 'ADU11'
});

export const successfulBiddersGet = ({ id }) => apiClient.get(`${RESOURCE}/${id}`, {
  operacionId: 'aduanas.successfulBidders.get',
  permiso: 'ADU28'
});

export const deactivateBidder = (id) => apiClient.delete(`${RESOURCE}/${id}`, {
  operacionId: 'aduanas.successfulBidders.deactivate'
});
